import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { HdContentLanguageService } from '@/app/human-design/chart/bodygraph/hd-content-language.service';
import { HdGateInfoService } from '@/app/human-design/chart/bodygraph/hd-gate-info.service';
import {
  HD_NOT_SELF_BY_IMPACT_ORDER,
  HD_NOT_SELF_CLASSIC_ORDER,
} from '@/app/human-design/chart/bodygraph/hd-center-not-self-metadata';
import { HdBodygraphCenter } from '@/app/human-design/chart/bodygraph/hd-bodygraph.models';

export type HdNotSelfSortMode = 'classic' | 'by-impact';

/**
 * Pagina die alle 9 Not-Self centers als cheat-sheet-kaarten toont.
 * Sorteerbare op klassieke volgorde (uit de NL deck-layout) of op impact-sterkte.
 * Taalwissel via inline `e-dropdown-menu` (zelfde patroon als de planet cheat-sheet).
 */
@Component({
  selector: 'hd-not-self-cheat-sheet-page',
  standalone: false,
  templateUrl: './hd-not-self-cheat-sheet-page.component.html',
  styleUrl: './hd-not-self-cheat-sheet-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HdNotSelfCheatSheetPageComponent {
  private readonly contentLang = inject(HdContentLanguageService);
  protected readonly gateInfo = inject(HdGateInfoService);

  protected readonly sortMode = signal<HdNotSelfSortMode>('classic');

  protected readonly orderedCenters = computed<readonly HdBodygraphCenter[]>(() =>
    this.sortMode() === 'classic' ? HD_NOT_SELF_CLASSIC_ORDER : HD_NOT_SELF_BY_IMPACT_ORDER,
  );

  protected readonly title = computed(() =>
    this.gateInfo.notSelfTitleIn(this.contentLang.effectiveLang()),
  );

  protected onSortModeToggle(event: Event): void {
    if (!(event.target instanceof HTMLInputElement)) {
      return;
    }
    // OFF = classic (default), ON = by impact/rank.
    this.sortMode.set(event.target.checked ? 'by-impact' : 'classic');
  }
}
